mutation DeleteAiGeneratedMaterial($input: DeleteAiGeneratedMaterialInput!) {
  deleteAiGeneratedMaterial(input: $input) {
    success
    materialId
    error
  }
}
